import { Outlet } from 'react-router-dom';
import { usePageTitle } from '@/shared/lib/use-page-title';
import './service-shell.css';

export function ServiceShell() {
  const { contentRef } = usePageTitle();

  return (
    <div className="service-shell">
      <h1 className="sr-only">깊콘 쿠폰</h1>
      <header className="service-shell__header">
        <span className="service-shell__logo">
          <img src="/images/logo-mark.svg" alt="" />
          깊콘
        </span>
      </header>
      <div className="service-shell__content" ref={contentRef} tabIndex={-1}>
        <Outlet />
      </div>
      <footer className="service-shell__footer safe-bottom">
        <ul className="service-shell__footer-list">
          <li>(주) 스퀘어노트</li>
          <li>1522-4293</li>
          <li>contact@squareknot.co.kr</li>
        </ul>
      </footer>
    </div>
  );
}
